import {ref} from "vue";
import type {Ref} from "vue";

export interface UsePaginationDefaults {
    pageNumber?: number,
    pageSize?: number,
}


export const usePagination = (
    defaults?: UsePaginationDefaults
) => {

    const pageNumber = ref<number>(defaults?.pageNumber ?? 1);
    const pageSize = ref<number>(defaults?.pageSize ?? 25);
    const totalCount = ref<number>(0);

    const setPageNumber = (page: number) => {
        pageNumber.value = page;
    }

    const setPageSize = (size: number) => {
        pageSize.value = size;
    }

    const setTotalCount = (count: number) => {
        totalCount.value = count;
    }

    return {
        pageNumber,
        pageSize,
        totalCount,
        setPageNumber,
        setPageSize,
        setTotalCount
    };
}
